const initialState = {
  selectedCategory: "all",
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "SET_SELECTED_CATEGORY":
      return { ...state, selectedCategory: payload };

    default:
      return state;
  }
};
